import React from 'react';
import { StockStatus as Status } from '../../../@types/stock.enum';
import { useStoreStockQuery } from '../../api/stock';
import { getHeading, getText } from './utils';
import StyledStockStatus from '../../styled/StockStatus';

interface IStockStatusCard {
  stockRequest: IItemStockRequest;
  toggleShowAll: () => void;
  userStore?: ILimitedStore;
}

const StockStatusCard = ({ stockRequest, toggleShowAll, userStore }: IStockStatusCard) => {
  const { data: storeStock, isLoading: loadingStock } = useStoreStockQuery(
    stockRequest,
    userStore?.storeId,
  );
  const status = storeStock?.status === undefined ? Status.Unavailable : storeStock.status;

  return (
    <StyledStockStatus
      heading={getHeading(status, userStore?.storeName)}
      loading={loadingStock}
      onClick={toggleShowAll}
      status={status}
      store={userStore?.storeName}
      text={getText(storeStock)}
      quantity={storeStock?.availableItems}
    />
  );
};

export default StockStatusCard;
